// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"325c6ce0","40":"baff734a","90":"4828bee4","147":"6b5a11e6","187":"9a0a994f","462":"b2ee4f0f","477":"b131f6d7"}[chunkId] + ".css";
};